const CouponCode4i = function(s_account){
	const common = new CartCommon();
	const omniture = common.Omniture(s_account);
	const messages = common.Messages;
	const openFormBtn = document.getElementById("btnEnterCouponCode");
	const couponDiv = document.getElementById("divCouponCode");
	
	let couponInput, couponError;
	
	const init = () =>{
		document.addEventListener("click", couponEvents);
	};
	
	const couponEvents = (e) =>{
		if(e.target.id == "btnApplyCouponCode"){
			e.preventDefault();
			validateCoupon();
		}else if(e.target.id == "btnCancelCouponCode"){
			e.preventDefault();
			hideCouponForm();
		}else if(e.target.id == "removeCouponCode"){
			e.preventDefault();
			submitDelete();
		}else if(e.target.id == "btnEnterCouponCode"){
			e.preventDefault();
			showCouponForm();
		}	
	};

	const showCouponForm = () => {
		openFormBtn.setAttribute("aria-expanded", "true");
		openFormBtn.classList.add("hide");
		couponDiv.classList.remove("hide");
		couponInput = document.getElementById("txtCouponCode");
		couponInput.focus();
	};
				
	const validateCoupon = () => {
		const couponCode = couponInput.value.toUpperCase();
		if (couponCode) submitCoupon(couponCode);
		else showError("Oops! The coupon code is not valid. Please Try Again.");
	};
				
	const showError = (errMsg) => {
		couponError = document.getElementById("couponCodeError");
		couponError.classList.remove("hide");
		couponError.textContent = errMsg;
		couponInput.classList.add("input-validation-error");
		couponInput.setAttribute("aria-invalid", "true");
		couponInput.focus();
	};
	
	const hideCouponForm = () => {
		openFormBtn.setAttribute("aria-expanded", "false");
		openFormBtn.classList.remove("hide");
		openFormBtn.focus();
		couponDiv.classList.add("hide");
		if(couponError) couponError.classList.add("hide");
		couponInput.classList.remove("input-validation-error");
		couponInput.removeAttribute("aria-invalid");
		couponInput.value = "";
	};
	
	const submitCoupon = async (code) => {
		common.ShowBusy();
		let responseJSON;	        
		try{
			const response = await fetch('/cart/addcoupon', { 
				method: 'POST', 
				body: JSON.stringify({ cartId: common.CartID, couponCode: code }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": common.Token, "RequestVerificationToken": common.Token }
			});
			
			if(!response.ok) throw new Error("Error processing add coupon code request");
			responseJSON = await response.json();
		}catch(error){
			showAddError(messages.couponError);
		}
		
		if(responseJSON){
			if (responseJSON.Success) addCouponSuccess(responseJSON, code);
			else showAddError(responseJSON.Message);
		}
	};
	
	const showAddError = (msg) => {
		showError(msg);
		common.HideBusy();
	};
	
	const addCouponSuccess = (data, code) =>{
		if (!data.ItemCount) {
			location.reload(true);
		} else {
			hideCouponForm();
			const cartSub = document.getElementById("cartSub");
			const removeCodeBtn = document.getElementById("removeCouponCode");
			const successDiv = document.getElementById("couponApplied");
			
			cartSub.textContent = "";
			removeCodeBtn.setAttribute("title", removeCodeBtn.getAttribute("title") + code);
			removeCodeBtn.setAttribute("data-coupon-code", code);
			successDiv.innerHTML = code + successDiv.innerHTML;
			
			const cartItemCounts = document.querySelectorAll(".cartItemCount");
			for (let i = 0; i < cartItemCounts.length; i++) {
				cartItemCounts[i].innerHTML = data.ItemCount;
			}
			
			cartSub.innerHTML = data.SubTotal;
			const discountAmount = document.getElementById("couponDiscountAmount");
			const couponsDiv = document.getElementById("divShowCouponCodes");
			discountAmount.innerHTML = data.CouponTotal;
			couponsDiv.classList.remove("hide");
			removeCodeBtn.focus();
			common.CheckCartHasCoupon();
			common.UpdateHeaderCartSummary(data);
		}
		omniture.AddCouponCode(code);
		common.HideBusy();
	};
	
	const submitDelete = async () => {
		common.ShowBusy();
		const code = document.getElementById("removeCouponCode").getAttribute("data-coupon-code");

		let responseJSON;
		try{
			const response = await fetch('/cart/deletecoupon', { 
				method: 'POST', 
				body: JSON.stringify({ cartId: common.CartID, couponCode: code }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": common.Token,"RequestVerificationToken": common.Token }
			});
			
			if(!response.ok) throw new Error("Error processing delete coupon code request");
			responseJSON = await response.json();
		}catch(error){
			showDeleteError(messages.deleteCouponError);
		}
		
		if(responseJSON){
			if (responseJSON.Success) deleteCouponSuccess(responseJSON, code);
			else showDeleteError(responseJSON.Message);
		}
	};
	
	const showDeleteError = (msg) => {
		common.ShowMessage(msg);
		common.HideBusy();
	};
	
	const deleteCouponSuccess = (data, code) => {
		if (!data.ItemCount) {
			location.reload(true);
		} else {
			const cartSub = document.getElementById("cartSub");
			const removeCodeBtn = document.getElementById("removeCouponCode");
			const successDiv = document.getElementById("couponApplied");
			cartSub.textContent = "";
			document.getElementById("divShowCouponCodes").classList.add("hide");
			removeCodeBtn.setAttribute("title", removeCodeBtn.getAttribute("title").replace(code, ""));
			removeCodeBtn.setAttribute("data-coupon-code", "");
			successDiv.innerHTML = successDiv.innerHTML.replace(code, "");
			
			const cartItemCounts = document.querySelectorAll(".cartItemCount");
			for (let i = 0; i < cartItemCounts.length; i++) {
				cartItemCounts[i].innerHTML = data.ItemCount;
			}
			
			cartSub.innerHTML = data.SubTotal;
			const discountAmount = document.getElementById("couponDiscountAmount");
			const checkoutBtn = document.getElementById("orderSummaryBox").getElementsByClassName("btnCheckOut")[0];
			discountAmount.innerHTML = data.CouponTotal;
			checkoutBtn.focus();
			common.CheckCartHasCoupon();
			common.UpdateHeaderCartSummary(data);
			common.HideMessage();
			common.HideBusy();
		}
	};
				
	return{
		Init: init
	};
};